module.exports = __webpack_public_path__ + "static/img/bg1.4b84b45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/bg1.jpg
// module id = 0e5G
// module chunks = 0